import { Pipe, PipeTransform } from '@angular/core';

import * as _ from 'lodash-es';
declare var require: any;

@Pipe({
  name: 'fieldtitle'
})
export class FieldtitlePipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {
    return _.startCase(String(value).replace(new RegExp("_", 'g')," "));
  }

}
